import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { AccountantPouchOperationEntity } from '../../domain/entities/AccountantPouchOperationEntity'
import type { AccountantPouchOperationListedAdminDto } from '@/backend/market'

export class AccountantPouchOperationModel extends AccountantPouchOperationEntity {
  constructor(dataDto: AccountantPouchOperationListedAdminDto) {
    super()
    mapEntityProperties<AccountantPouchOperationModel>(this, dataDto, {
      map: {
        startDate: dataDto.dateTime
      }
    })
  }
}
